import { render, staticRenderFns } from "./kxsUserAgreement.vue?vue&type=template&id=dada783e&scoped=true"
import script from "./kxsUserAgreement.vue?vue&type=script&lang=js"
export * from "./kxsUserAgreement.vue?vue&type=script&lang=js"
import style0 from "./kxsUserAgreement.vue?vue&type=style&index=0&id=dada783e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dada783e",
  null
  
)

export default component.exports